import GetShopOrderItemRequestModelBase from '../_generated/modelBases/get-shop-order-item-request-model-base';

export default class GetShopOrderItemRequestModel extends GetShopOrderItemRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
